(function() {
  var attempts = 0;

  function init() {
    var tiersContainer = document.querySelector('.parissa-tiers');
    var qtyInput = document.querySelector('product-form-component input[name="quantity"]');

    if (!tiersContainer || !qtyInput) {
      if (attempts < 30) {
        attempts++;
        setTimeout(init, 200);
      }
      return;
    }

    var tiers = tiersContainer.querySelectorAll('.parissa-tier');

    tiers.forEach(function(tier) {
      tier.addEventListener('click', function() {
        var qty = parseInt(tier.dataset.qty) || 1;
        tiers.forEach(function(t) { t.classList.remove('parissa-tier--active'); });
        tier.classList.add('parissa-tier--active');
        tier.querySelector('input[type="radio"]').checked = true;

        qtyInput.value = qty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

        var wrapper = qtyInput.closest('.quantity-selector, quantity-selector-component');
        if (wrapper) {
          var event = new Event('input', { bubbles: true });
          qtyInput.dispatchEvent(event);
        }
      });
    });

    var qtyButtons = document.querySelectorAll('.quantity-minus, .quantity-plus');
    qtyButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setTimeout(function() {
          var currentQty = parseInt(qtyInput.value) || 1;
          tiers.forEach(function(t) {
            var tierQty = parseInt(t.dataset.qty);
            t.classList.toggle('parissa-tier--active', tierQty === currentQty);
            var radio = t.querySelector('input[type="radio"]');
            if (radio) radio.checked = (tierQty === currentQty);
          });
        }, 100);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
